<template>
  <div class="ImageWidget">
    <div class="bg flexCenter" :style="widgetStyle">
      <div class="text flexCenter" v-html="title">
        
      </div>
    </div>
    <div class="subTitle" v-if="!!subTitle">
      {{subTitle}}
    </div>
    <div class="link" v-if="!!ctaText">
      <a :href="ctaHref" @click="onBtnClick">{{ctaText}}</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ImageWidget',
    data(){
      return {
      }
    },
    components:{
    },
    props: {
      title: {
        type: String,
        default: ""
      },
      img: {
        type: String,
        default: ""
      },
      subTitle: {
        type: String,
        default: ""
      },
      ctaText: {
        type: String,
        default: ""
      },
      ctaHref: {
        type: String,
        default: ""
      },
      bgImageStyle: {
        type: Object,
        default: ()=>{
          return {
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }
        }
      }
    },
    methods: {
      onBtnClick: function(e){
        e.preventDefault();
        if(!!window.location.hash){
          var event = new CustomEvent('hashClicked', {
            detail: {
              a: e.target
            }
          });
          window.dispatchEvent(event);
        }else{
          window.location.href = e.target.getAttribute('href');
        }
      }
    },
    computed: {
      widgetStyle(){
        return {
          backgroundImage: !!this.img ? `url(${this.img})` : '',
          backgroundSize: !!this.bgImageStyle ? this.bgImageStyle.backgroundSize : 'cover',
          backgroundPosition: !!this.bgImageStyle ? this.bgImageStyle.backgroundPosition : 'center',
          backgroundRepeat: !!this.bgImageStyle ? this.bgImageStyle.backgroundRepeat : 'no-repeat',
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  .bg{
    height: 235px;
  }

  .flexCenter{
    display: flex;
    justify-content: center;
    align-content: stretch;
    flex-direction: column;
  }

  a{
    font-weight: 600;
  }

  .text{
    flex: 1;
    font-family: Helvetica, sans-serif;
    font-weight: bold;
    font-size: 28px;
    line-height: 34px;
    text-align: center;
    color: #fff;
    background: linear-gradient(to bottom, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0) 100%);
  }

  .subTitle, .link{
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
  }

  .bg{
    margin-bottom:  53px;
  }

  .subTitle{
    color: #555555;
    margin-top: 22px;
  }
  .link:link, .link:visited, .link:hover, .link:active{
    color: #614AE4;
    text-decoration: none;
  }

</style>
